export default {
  INDEX: "/",
  ERROR: '/error',
  CREATE: "/create",
  RESULT: "/r/:hash",
  RESULT_TAB: "/r/:hash/:tabIndex",
};
